import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useHelpDeskTicketStatusActions from '../hooks/useHelpDeskTicketStatusActions';
import { ResolveButton as BaseResolveButton } from './shared';
import HelpDeskTicketActionsDropdown from './HelpDeskTicketActionsDropdown';
import HelpDeskTicketActionsModals from './HelpDeskTicketActionsModals';

// region: Styled components

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ResolveButton = styled(BaseResolveButton)`
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
`;

// region: Component

const HelpDeskTicketActions = ({ ticket, accountId }) => {
  const { t } = useContext(ConfigContext);

  const {
    isClosed,
    isResolved,
    isLoading,
    resolutionTimeoutHours,
    showCloseConfirm,
    setShowCloseConfirm,
    showResolveConfirm,
    setShowResolveConfirm,
    isMenuCustomPickerVisible,
    setIsMenuCustomPickerVisible,
    handleResolve,
    handleResolveConfirm,
    handleSnooze,
    handleUnsnooze,
    handleUnresolve,
    handleClose,
    handleReopen,
    handleCloseTicketRequest,
    handleTogglePending,
    isUnread,
    handleToggleRead
  } = useHelpDeskTicketStatusActions({ ticket, accountId });

  return (
    <>
      <ActionsRow>
        {!isResolved && (
          <ResolveButton $compact={true} onClick={handleResolve} disabled={isLoading || isClosed}>
            {t('help_desk_mark_resolved')}
          </ResolveButton>
        )}

        <HelpDeskTicketActionsDropdown
          ticket={ticket}
          isLoading={isLoading}
          isMenuCustomPickerVisible={isMenuCustomPickerVisible}
          onCustomPickerVisibleChange={setIsMenuCustomPickerVisible}
          onSnooze={handleSnooze}
          onUnsnooze={handleUnsnooze}
          onUnresolve={handleUnresolve}
          onReopen={handleReopen}
          onCloseTicketRequest={handleCloseTicketRequest}
          onTogglePending={handleTogglePending}
          isUnread={isUnread}
          onToggleRead={handleToggleRead}
          dataTestId="ticket-actions-menu"
        />
      </ActionsRow>

      <HelpDeskTicketActionsModals
        showCloseConfirm={showCloseConfirm}
        onCloseConfirmDismiss={() => setShowCloseConfirm(false)}
        onCloseConfirm={handleClose}
        showResolveConfirm={showResolveConfirm}
        onResolveConfirmDismiss={() => setShowResolveConfirm(false)}
        onResolveConfirm={handleResolveConfirm}
        resolutionTimeoutHours={resolutionTimeoutHours}
      />
    </>
  );
};

export default HelpDeskTicketActions;
